import React from 'react';
import { Box, Container, Typography, Chip } from '@mui/material';
import HealthAndSafetyIcon from '@mui/icons-material/HealthAndSafety';
import WorkOffIcon from '@mui/icons-material/WorkOff';

const PRIMARY = '#FF7518';
const DARK = '#4a2d08';
const DARK_BG = '#0f0f0f';

export function Careers() {
  return (
    <Box sx={{ bgcolor: '#ffffff', minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      {/* Minimal nav */}
      <Box sx={{ bgcolor: DARK_BG, py: 2, borderBottom: '1px solid rgba(255,255,255,0.08)' }}>
        <Container maxWidth="lg">
          <Box
            component="a"
            href="/"
            sx={{ display: 'inline-flex', alignItems: 'center', gap: 1, textDecoration: 'none' }}
          >
            <HealthAndSafetyIcon sx={{ color: PRIMARY, fontSize: 26 }} />
            <Typography variant="h6" sx={{ fontWeight: 700, color: '#fff' }}>
              BaaStream
            </Typography>
          </Box>
        </Container>
      </Box>

      {/* Hero */}
      <Box sx={{ bgcolor: DARK_BG, py: { xs: 8, md: 12 } }}>
        <Container maxWidth="md" sx={{ textAlign: 'center' }}>
          <Chip
            label="Careers"
            size="small"
            sx={{ bgcolor: 'rgba(255,117,24,0.15)', color: PRIMARY, fontWeight: 600, mb: 3 }}
          />
          <Typography
            variant="h1"
            sx={{ fontSize: { xs: '2.2rem', md: '3rem' }, fontWeight: 800, color: '#fff', lineHeight: 1.2, mb: 3 }}
          >
            Join the{' '}
            <Box component="span" sx={{ color: PRIMARY }}>
              BaaStream
            </Box>{' '}
            team
          </Typography>
          <Typography variant="body1" sx={{ color: 'rgba(255,255,255,0.65)', fontSize: '1.1rem', lineHeight: 1.8 }}>
            We're building the compliance layer for healthcare engineering — and we're just getting started.
          </Typography>
        </Container>
      </Box>

      {/* No positions */}
      <Box sx={{ flex: 1, display: 'flex', alignItems: 'center' }}>
        <Container maxWidth="sm" sx={{ textAlign: 'center', py: { xs: 8, md: 12 } }}>
          <Box
            sx={{
              width: 96,
              height: 96,
              borderRadius: '50%',
              bgcolor: 'rgba(255,117,24,0.08)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              mx: 'auto',
              mb: 4,
            }}
          >
            <WorkOffIcon sx={{ fontSize: 44, color: PRIMARY }} />
          </Box>

          <Typography variant="h4" sx={{ fontWeight: 700, color: DARK, mb: 2 }}>
            No open positions right now
          </Typography>
          <Typography variant="body1" sx={{ color: '#666', lineHeight: 1.8, mb: 4 }}>
            We don't have any open roles at the moment, but we're always interested in hearing from
            talented people who care about healthcare compliance and developer tooling.
          </Typography>
          <Typography variant="body1" sx={{ color: '#666', lineHeight: 1.8, mb: 5 }}>
            If that's you, drop us a note at{' '}
            <Box
              component="a"
              href="mailto:connect@baastream.com"
              sx={{ color: PRIMARY, fontWeight: 600, textDecoration: 'none', '&:hover': { textDecoration: 'underline' } }}
            >
              connect@baastream.com
            </Box>{' '}
            — we'd love to stay in touch.
          </Typography>

          <Box
            component="a"
            href="/"
            sx={{
              display: 'inline-block',
              px: 4,
              py: 1.5,
              bgcolor: PRIMARY,
              color: '#fff',
              borderRadius: 2,
              fontWeight: 600,
              textDecoration: 'none',
              fontSize: '0.95rem',
              '&:hover': { opacity: 0.9 },
            }}
          >
            ← Back to Home
          </Box>
        </Container>
      </Box>

      {/* Footer */}
      <Box sx={{ bgcolor: DARK_BG, py: 4 }}>
        <Container maxWidth="lg">
          <Typography variant="caption" sx={{ color: 'rgba(255,255,255,0.3)', display: 'block', textAlign: 'center' }}>
            © {new Date().getFullYear()} Monks Do Work. All rights reserved.
          </Typography>
        </Container>
      </Box>
    </Box>
  );
}
